module.exports = __webpack_public_path__ + "static/assets/9a1be90552ed9ae76f6c4b963e9e3fa7.png";